import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/SoldOut.css';
import '../styles/Home.css';
import WhatsappCTA from '../components/WhatsappCTA';

const translations = {
  en: {
    title: "Financing Options",
    h2_1: "Secure Your Land Today—24 Months Interest-Free!",
    p1: "Dreaming of owning land but worried about upfront costs? Now’s your chance to claim your slice of paradise without financial stress. For a limited time, we’re offering a 24-month interest-free payment plan—making it easier than ever to invest in your future while prices are still rising.",
    h2_2: "Why choose this plan?",
    bullet1: "📍 Zero interest for 24 months: Pay over time without fees or penalties.",
    bullet2: "📍 Flexible terms: Start with a low initial payment and customize your schedule.",
    bullet3: "📍 Lock in today’s prices: Land values here are climbing—act now to secure your lot at current rates.",
    bullet4: "📍 Extended financial options: Need more time? Ask us about tailored solutions to fit your budget.",
    h2_3: "Book now",
    button: "Book"
  },
  es: {
    title: "Opciones de Financiamiento",
    h2_1: "¡Asegura tu Terreno Hoy—24 Meses Sin Intereses!",
    p1: "¿Sueñas con ser dueño de un terreno pero te preocupa el pago inicial? Ahora es tu oportunidad de reclamar tu porción de paraíso sin estrés financiero. Por tiempo limitado, ofrecemos un plan de pagos sin intereses por 24 meses—facilitando más que nunca invertir en tu futuro mientras los precios siguen subiendo.",
    h2_2: "¿Por qué elegir este plan?",
    bullet1: "📍 Cero intereses por 24 meses: Paga con el tiempo sin cargos ni penalizaciones.",
    bullet2: "📍 Términos flexibles: Empieza con un pago inicial bajo y personaliza tu calendario.",
    bullet3: "📍 Bloquea precios actuales: Los valores de la tierra aquí están subiendo—actúa ahora para asegurar tu lote a tasas actuales.",
    bullet4: "📍 Opciones financieras extendidas: ¿Necesitas más tiempo? Pregunta sobre soluciones personalizadas que se ajusten a tu presupuesto.",
    h2_3: "Reserva ahora",
    button: "Reservar"
  }
};

const Finance = ({ language }) => {
  return (
    <div className="testimonial">
      <div className="testimonial-text">
        <h1>{translations[language].title}</h1>
        
        <h2>{translations[language].h2_1}</h2>
        <p>{translations[language].p1}</p>

        <h2>{translations[language].h2_2}</h2>
        <div className="callout-box">
          <p>{translations[language].bullet1}</p>
          <p>{translations[language].bullet2}</p>
          <p>{translations[language].bullet3}</p>
          <p>{translations[language].bullet4}</p>
        </div>

        <WhatsappCTA language={language}/>

        <h2>{translations[language].h2_3}</h2>
        <Link to="/contact" className="cta-button">
          {translations[language].button}
        </Link>
      </div>
    </div>
  );
};

export default Finance;